import React from 'react';
import Formsy from 'formsy-react';
import { Redirect } from 'react-router-dom';
import MenuSelectionCard from '../shared/MenuSelectionCard';
import {
  defaultMenuSelection,
  generateMenuSelections,
  populateMenuSelections,
  setLockStatus
} from '../../helpers/menuSelection';
import {
  isEmptyObj,
  stringfyServerErrors,
  limitStringLength
} from '../../helpers/util';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import Loader from '../shared/Loader';
import Spinner from '../shared/Spinner';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { menuSelectionMaxQuantity } from '../../const';
import MenuSelectionModal from '../shared/MenuSelectionModal';
import BackButton from '../shared/BackButton';
import FormsySimpleInput from '../form/FormsySimpleInput';
import FormsyInput from '../form/FormsyInput';
import { maskServiceDateNoYear } from '../../masks';
import SVGSuccessCheck from '../../svg/SuccessCheck';
import SkipWeekModal from './SkipWeekModal';
import withTracker from '../withTracker';
import { portionSwitch } from '../../masks';

class MenuSelection extends React.Component {
  state = {
    id: 0,
    menu: {},
    menu_selections: [],
    activeSelectionIndex: -1,
    notes: '',
    start_time: '',
    isLocked: true,
    skipped: false,

    isLoading: true,
    isValid: false,
    isModalOpen: false,
    isSkipModalOpen: false,
    isReviewOpen: false,
    isRequestOut: false
  };

  render() {
    const { courses = [] } = this.state.menu;
    const { isRequestOut } = this.state;
    const total = this.calcTotalSelections();

    if (this.state.isLoading) return <Loader />;

    if (isEmptyObj(this.state.menu)) {
      return <Redirect to="/client-profile" />;
    }

    // desktop version
    const menu = this.state.menu_selections
      .filter(selection => selection.quantity > 0)
      .map(selection => (
        <div
          key={selection.dish_id}
          className="on-boarding-nav-item__menu--row"
        >
          <div
            className="menu-selection-control"
            onClick={() => this.clearMenuSelection(selection)}
          >
            x
          </div>
          <span className="p on-boarding-nav-item__menu--count">
            {selection.quantity}
          </span>
          <p className="p on-boarding-nav-item__menu--name">
            {selection.dish.name}

            <span className="p on-boarding-nav-item__menu--notes">
              {limitStringLength(selection.notes, 120)}
            </span>
          </p>
        </div>
      ));

    let buttonCopy;
    if (!isRequestOut) {
      buttonCopy = this.state.isValid ? 'Save Menu' : 'Choose Up To Six';
    } else {
      // remove copy so a loader can be positioned over it
      buttonCopy = '';
    }

    const controlClasses = ['menu-selection__control'];
    if (this.state.isReviewOpen) {
      controlClasses.push('menu-selection__control--open');
    }

    const lockClasses = ['menu-selection-lock'];
    if (this.state.isLocked) {
      lockClasses.push('menu-selection-lock--open');
    }

    let lockTitle = 'Your Menu is Locked';
    let lockSubtitle =
      'If you have any last minute needs prior to your service, please call the Culintistas.';
    let lockCTA = 'Back To My Account';

    if (this.state.skipped) {
      lockTitle = 'You have skipped this week.';
      lockSubtitle =
        'If you have decided not to skip this week, please email The Culinistas.';
      lockClasses.push('skipped-service');
    }

    return (
      <div className="menu-selection">
        <div className="menu-selection__wrap">
          <div className="menu-selection__main">
            <div className="menu-selection-counter__bar">
              <p className="menu-selection-counter__p p p--bold">
                Menu For {maskServiceDateNoYear(this.state.start_time)}
              </p>
              {!this.state.isLocked && total > 0 && (
                <p className="menu-selection-counter__count">{total}</p>
              )}
              {this.state.isLocked && (
                <span className="menu-selection-counter__lock">
                  <SVGSuccessCheck />
                </span>
              )}
            </div>

            <BackButton defaultUrl="/client-profile" />
            {courses && courses.map(course => this.renderCourse(course))}

            <div className={lockClasses.join(' ')}>
              <div className="menu-selection-lock__wrap">
                <div className="menu-selection-lock__content">
                  <div className="menu-selection-thanks__h1">{lockTitle}</div>
                  <div className="menu-selection-thanks__p">{lockSubtitle}</div>
                  <div className="menu-selection-thanks__cta">
                    <a className="btn btn--solid-blue" href="/">
                      {lockCTA}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <MenuSelectionModal
              isOpen={this.state.isModalOpen}
              index={this.state.activeSelectionIndex}
              menu_selection={
                this.state.activeSelectionIndex >= 0
                  ? this.state.menu_selections[this.state.activeSelectionIndex]
                  : {}
              }
              updateMenuSelection={this.updateMenuSelection}
              closeModal={this.closeModal}
            />
          </div>
          <Formsy
            className={controlClasses.join(' ')}
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <FormsySimpleInput
              type="hidden"
              name="total"
              value={total}
              validations="isGreaterThan:0"
            />
            <FormsySimpleInput
              type="hidden"
              name="locked"
              value={this.state.isLocked}
              validations="isFalse"
            />
            <div className="menu-selection__summary">
              {/*<p className="p">Total: {total}</p>*/}
              <div className="menu-selection__selected">
                <p
                  className="menu-selection__back a--blue"
                  onClick={this.toggleReview}
                >
                  Back To Menu
                </p>
                <p className="menu-selection__selected-date p p--bold">
                  Menu For {maskServiceDateNoYear(this.state.start_time)}
                </p>
                {menu}
              </div>

              <div className="menu-selection__instructions">
                <p className="p p--bold">Special Instructions</p>
                <p className="p">
                  Enter any other preferences about your menu, groceries, chef,
                  or service here.
                </p>
                <FormsyInput
                  type="text"
                  placeholder="I would like to..."
                  name="special_instructions"
                  value={this.state.special_instructions}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="menu-selection__ctas">
              <div className="menu-selection__submit-wrap">
                <Spinner
                  color="#fff"
                  scale={0.5}
                  isRequestOut={isRequestOut}
                ></Spinner>
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width menu-selection__cta-submit"
                  value={buttonCopy}
                  disabled={!this.state.isValid || this.state.isRequestOut}
                />
              </div>
              <button
                type="button"
                className="btn btn--solid-blue btn--full-width menu-selection__cta-summary"
                onClick={this.toggleReview}
                disabled={!this.state.isValid || this.state.isRequestOut}
              >
                Review Menu & Instructions
              </button>
              {/*{total === 0 && }*/}
              <button
                className="btn btn--link btn--full-width menu-selection__cta-skip"
                type="button"
                onClick={this.openSkipModal}
                disabled={this.state.isLocked || this.state.isRequestOut}
              >
                Skip This Week
              </button>
            </div>
          </Formsy>
        </div>
        <SkipWeekModal
          isOpen={this.state.isSkipModalOpen}
          closeModal={this.closeSkipModal}
          skipWeek={this.handleSkipWeek}
        />
      </div>
    );
  }

  renderCourse(course) {
    const { dishes = [] } = course;
    return (
      <div key={course.id} className="menu-selection-course">
        <div className="menu-selection-course__name">{course.name}</div>
        <div className="menu-selection-cards">
          {dishes &&
            dishes.map(dish => {
              const index = this.state.menu_selections.findIndex(
                selection => selection.menu_dish_id === dish.id
              );
              return (
                <MenuSelectionCard
                  key={dish.id}
                  dish={dish}
                  index={index}
                  menu_selection={
                    index >= 0
                      ? this.state.menu_selections[index]
                      : defaultMenuSelection(dish)
                  }
                  updateMenuSelection={this.updateMenuSelection}
                  openModal={this.openModal}
                  closeModal={this.closeModal}
                />
              );
            })}
        </div>
      </div>
    );
  }

  getMenuSelectionPayload = menuSelections => {
    // modify the payload if we need to here.
    const menu_selections = menuSelections
      .filter(sel => sel.quantity > 0)
      .map(sel => {
        const selection = {
          ...sel,
          portion: portionSwitch(this.state.client.portion_size)
        };
        delete selection.dish;

        return selection;
      });
    return {
      menu_selections,
      special_instructions: this.state.special_instructions
    };
  };

  swapInDuplicates = () => {
    return new Promise((resolve, reject) => {
      const menu_selections = [...this.state.menu_selections];
      const swaps = menu_selections
        .filter(sel => sel.quantity > 0 && sel.menu_dish_id === sel.dish_id)
        .map(sel => sel.dish_id);
      if (swaps) {
        this.duplicateDishes(swaps)
          .then(dishes => {
            dishes.forEach(dish => {
              const index = menu_selections.findIndex(
                sel => sel.dish_id === dish.parent_dish_id
              );
              menu_selections[index] = {
                ...menu_selections[index],
                dish,
                dish_id: dish.id
              };
            });
            resolve(menu_selections);
          })
          .catch(err =>
            this.props.addMessage({
              className: 'error',
              message: stringfyServerErrors(err)
            })
          );
      } else {
        resolve(menu_selections);
      }
    });
  };

  duplicateDishes = dishIds =>
    Promise.all(dishIds.map(this.mapDuplicateRequest));

  mapDuplicateRequest = dishID =>
    serviceAPI.duplicateDish(this.state.id, dishID);

  handleSubmit = () => {
    this.setState({ isRequestOut: true });
    this.swapInDuplicates().then(menu_selections => {
      this.setState({ menu_selections });
      serviceAPI
        .updateMenuSelections(
          this.state.id,
          this.getMenuSelectionPayload(menu_selections)
        )
        .then(res => {
          this.props.history.push(`/menu-selection/${this.state.id}/thanks`);
        })
        .catch(err =>
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(err)
          })
        )
        .finally(() => this.setState({ isRequestOut: false }));
    });
  };

  handleSkipWeek = (reason = '') => {
    serviceAPI
      .skipService(this.state.id, reason)
      .then(res => {
        this.setState({
          skipped: true,
          isLocked: true,
          isSkipModalOpen: false
        });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
        this.setState({ isSkipModalOpen: false });
      });
  };

  handleInvalidSubmit = () => console.log('handleInvalidSubmit');

  handleValid = () => this.setState({ isValid: true });
  handleInvalid = () => this.setState({ isValid: false });

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  toggleReview = () =>
    this.setState({ isReviewOpen: !this.state.isReviewOpen });

  openModal = activeSelectionIndex =>
    this.setState({ isModalOpen: true, activeSelectionIndex });
  closeModal = () =>
    this.setState({ isModalOpen: false, activeSelectionIndex: -1 });

  openSkipModal = () => this.setState({ isSkipModalOpen: true });
  closeSkipModal = () => this.setState({ isSkipModalOpen: false });

  calcTotalSelections = (menu_selections = this.state.menu_selections) => {
    return menu_selections.reduce(
      (accum, selection) => selection.quantity + accum,
      0
    );
  };

  clearMenuSelection = menu_selection => {
    const index = this.state.menu_selections.findIndex(
      sel => sel.menu_dish_id === menu_selection.menu_dish_id
    );
    menu_selection.quantity = 0;
    menu_selection.notes = '';
    this.updateMenuSelection(index, menu_selection);
  };

  updateMenuSelection = (index, menu_selection) => {
    // if it's not in there, throw it at the end
    const menu_selections =
      index === -1
        ? [...this.state.menu_selections, menu_selection]
        : // if it is, updated it.
          [
            ...this.state.menu_selections.slice(0, index),
            { ...menu_selection },
            ...this.state.menu_selections.slice(
              index + 1,
              this.state.menu_selections.length
            )
          ];

    const total = this.calcTotalSelections(menu_selections);
    if (total > menuSelectionMaxQuantity)
      this.props.addMessage({
        className: 'error',
        message: 'Error - You can only select up to 6 dishes'
      });
    else {
      this.setState({ menu_selections });
    }
  };

  lookupMenu() {
    this.setState({ isLoading: true });

    const { id = 0 } = this.props.match.params;
    if (id > 0) {
      serviceAPI
        .getService(id)
        .then(
          ({
            menu,
            menu_selections: clientSelections = [],
            start_time,
            notes = '',
            special_instructions = '',
            skipped = false,
            client,
            ...rest
          }) => {
            // abort if there's no menu
            if (!menu) {
              this.props.addMessage({
                className: 'error',
                message: 'No menu available.'
              });
              this.setState({ isLoading: false });
              return;
            }
            const isLocked = skipped || setLockStatus(start_time);
            let menu_selections = [];
            // if we have menu_selections, populate menu_selections
            if (clientSelections.length > 0)
              menu_selections = populateMenuSelections(menu, clientSelections);
            // else, generate new menu_selections
            else if (menu && menu.courses)
              menu_selections = generateMenuSelections(menu);

            this.setState({
              id,
              menu,
              menu_selections,
              isLocked,
              client,
              start_time,
              notes: notes || '',
              special_instructions: special_instructions || '',
              skipped,
              isLoading: false
            });
          }
        )
        .catch(err => {
          this.setState({ isLoading: false });
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(err)
          });
        });
    }
  }

  componentDidMount() {
    this.lookupMenu();
  }
}
export default withSplashMessage(withTracker(MenuSelection));



// WEBPACK FOOTER //
// ./src/components/menuSelection/MenuSelection.js